
$(function () {
    $(".secret-generator-modal").each(function (idx, element) {

        var triggerId = $(element).data("trigger");
        var clientId = $(element).data("client");
        var linkId = $(element).data("link");

        var _copyToClipboard = function () {
            window.getSelection().selectAllChildren($(".secret-generator-modal .secret-box").get(0));
            document.execCommand("copy");
        };

        var _generateSecret = function () {
            const url = linkId ? "/apiclients/linksecretjson/" + linkId
                : "/apiclients/secretjson/" + clientId;
            $.ajax({
                url: url,
                method: "POST",
                success: function (d) {
                    if (d.Success) {
                        $(".secret-generator-modal .secret-box").html(d.Data);
                        $(".secret-generator-modal .alert").hide();
                        $(".secret-generator-modal .bounce-spinner").hide();
                        $(".secret-generator-modal .btn-copy").show();
                        $(".secret-generator-modal .secret-container").show();

                    }
                    else {
                        $(".secret-generator-modal .alert").html("Error: " + d.Error);
                        $(".secret-generator-modal .btn-copy").hide();
                        $(".secret-generator-modal .bounce-spinner").hide();
                        $(".secret-generator-modal .secret-container").hide();
                        $(".secret-generator-modal .alert").show();
                    }
                },
                error: function (x, s, e) {
                    $(".secret-generator-modal .alert").html("An error occurred. Please try again later");
                    $(".secret-generator-modal .btn-copy").hide();
                    $(".secret-generator-modal .bounce-spinner").hide();
                    $(".secret-generator-modal .secret-container").hide();
                    $(".secret-generator-modal .alert").show();
                }
            });
        };

        if (triggerId) {
            $("#" + triggerId).click(function () {
                $(".secret-generator-modal .alert").hide();
                $(".secret-generator-modal .bounce-spinner").show();
                $(".secret-generator-modal .btn-copy").hide();
                $(".secret-generator-modal .secret-container").hide();

                $(element).modal("show");
                _generateSecret();
            });

            $(".secret-generator-modal .btn-copy").click(function () {
                _copyToClipboard();

                $(this).removeClass("btn-sec").addClass("btn-alt");
                $(this).children("span.fas").removeClass("fa-copy").addClass("fa-check");
                $(this).children("span.btn-text").html("Copied Successfully!");

                var _self = this;

                setTimeout(function () {
                    $(_self).removeClass("btn-alt").addClass("btn-sec");
                    $(_self).children("span.fas").removeClass("fa-check").addClass("fa-copy");
                    $(_self).children("span.btn-text").html("Copy to clipboard");
                }, 5000);
            });

            $(".secret-generator-modal .btn-close").click(function () {
                window.location.reload();
            });
        }
    });
});